import { datadogLogs } from '@datadog/browser-logs'
import { Logger } from '@flatfile/shared-ui'
import { VITE_DATADOG_CLIENT_TOKEN, VITE_DATADOG_SITE, VITE_ENVIRONMENT, VITE_GIT_COMMIT } from '../config/build_vars'

// NOTE: this seems to initialize prior to main.tsx, so we can't use window.flatfile.configService here
export function initializeDatadogLogs() {
  try {
    datadogLogs.init({
      clientToken: VITE_DATADOG_CLIENT_TOKEN,
      site: VITE_DATADOG_SITE,
      forwardErrorsToLogs: true,
      service: 'new-dashboard',
      env: VITE_ENVIRONMENT ?? 'production', // we do not have an env var for prod in vercel - this will not be triggered locally
      version: VITE_GIT_COMMIT,
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error initializing Datadog Logs:', error)
  }
}

export function initializeLogging() {
  if (VITE_DATADOG_CLIENT_TOKEN) {
    initializeDatadogLogs()
  } else {
    console.error('Datadog client token is missing')
  }
}

const isDev = import.meta.env.DEV

function getLogger() {
  initializeLogging()
  const logger = new Logger(isDev, datadogLogs.getLogger('new-dashboard') || datadogLogs.createLogger('new-dashboard'))
  return logger
}

export const logger = getLogger()
